import React from 'react'
import PropTypes from 'prop-types'
import BureauCard from './BureauCard'

const BureauGrid = ({ bureaus, showChart, compact = false }) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    {bureaus.map((entry) => (
      <BureauCard key={entry.bureau} entry={entry} showChart={showChart} compact={compact} />
    ))}
  </div>
)

BureauGrid.propTypes = {
  bureaus: PropTypes.array.isRequired,
  showChart: PropTypes.bool,
  compact: PropTypes.bool,
}

export default BureauGrid
